/**
 * presentation-slider.js
 * Slider d'images pour la section "Présentation avec Slider"
 * - Init depuis .presentation-slider-section (porte les data-attrs)
 * - Navigation: flèches, dots, swipe
 * - Auto-slide + pause au survol
 * - Compatible éditeur Shopify (shopify:section:load/unload)
 */

(function () {
  // Espace de nom global pour debug et cleanup
  window.PresentationSlider = window.PresentationSlider || {
    instances: {}
  };

  /**
   * Initialise un slider
   * @param {string} sectionId - ID "sec_xxx" de la section (sans le préfixe shopify-section-)
   * @param {HTMLElement} container - Élément .presentation-slider-section
   * @param {{autoSlide?: boolean, slideDuration?: number}} options
   */
  function initSlider(sectionId, container, options) {
    if (!container) {
      console.warn('[PresentationSlider] container introuvable pour section', sectionId);
      return;
    }

    // Éviter double init
    if (container.getAttribute('data-initialized') === 'true') {
      // console.log('[PresentationSlider] déjà initialisé', sectionId);
      return;
    }
    container.setAttribute('data-initialized', 'true');

    // Options
    var settings = {
      autoSlide: !!(options && options.autoSlide),
      slideDuration: (options && parseInt(options.slideDuration, 10)) || 5000
    };

    // Élément racine du slider (celui qui contient .slide, flèches, dots)
    var slider = container.querySelector('[data-slider]');
    if (!slider) {
      console.warn('[PresentationSlider] [data-slider] manquant dans la section', sectionId);
      container.removeAttribute('data-initialized');
      return;
    }

    var slides = Array.from(slider.querySelectorAll('.slide'));
    var prevBtn = slider.querySelector('[data-prev]');
    var nextBtn = slider.querySelector('[data-next]');
    var dots = Array.from(slider.querySelectorAll('.dot'));
    var currentIndex = Math.max(0, slides.findIndex(s => s.classList.contains('active')));
    if (currentIndex === -1) currentIndex = 0;

    var timer = null;

    if (!slides.length) {
      console.warn('[PresentationSlider] aucune slide trouvée', sectionId);
      container.removeAttribute('data-initialized');
      return;
    }

    function render(index) {
      currentIndex = (index + slides.length) % slides.length;
      slides.forEach((s, i) => s.classList.toggle('active', i === currentIndex));
      dots.forEach((d, i) => d.classList.toggle('active', i === currentIndex));
    }

    function next() { render(currentIndex + 1); }
    function prev() { render(currentIndex - 1); }

    function start() {
      if (settings.autoSlide && slides.length > 1) {
        stop();
        timer = setInterval(next, settings.slideDuration);
      }
    }
    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    function restart() {
      stop();
      start();
    }

    // Listeners flèches
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        stop();
        next();
        start();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        stop();
        prev();
        start();
      });
    }

    // Dots
    dots.forEach((dot, i) => {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        stop();
        render(i);
        start();
      });
    });

    // Pause au survol
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);

    // Swipe mobile
    var touchStartX = 0;
    slider.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].screenX - touchStartX;
      if (Math.abs(dx) > 50) {
        stop();
        if (dx < 0) next(); else prev();
        start();
      }
    });

    // État initial
    render(currentIndex);
    start();

    // Sauvegarde instance pour cleanup
    window.PresentationSlider.instances[sectionId] = {
      container: container,
      stop: stop,
      cleanup: function () {
        stop();
        container.removeAttribute('data-initialized');
      }
    };
  }

  /**
   * Récupère sectionId + options depuis un conteneur .presentation-slider-section
   * et initialise.
   * @param {HTMLElement} container
   */
  function initFromContainer(container) {
    var wrapper = container.closest('[id^="shopify-section-"]');
    var sectionId = wrapper ? wrapper.id.replace('shopify-section-', '') : (container.dataset.sectionId || '');
    var autoSlide = (container.getAttribute('data-auto-slide') || 'false') === 'true';
    var slideDuration = parseInt(container.getAttribute('data-slide-duration'), 10) || 5000;
    initSlider(sectionId, container, { autoSlide: autoSlide, slideDuration: slideDuration });
  }

  // Init au chargement
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.presentation-slider-section').forEach(initFromContainer);
  });

  // Éditeur Shopify : section ajoutée
  document.addEventListener('shopify:section:load', function (e) {
    var container = e.target.querySelector('.presentation-slider-section');
    if (container) initFromContainer(container);
  });

  // Éditeur Shopify : section retirée
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.target.id ? e.target.id.replace('shopify-section-', '') : '';
    var inst = id && window.PresentationSlider.instances[id];
    if (inst && inst.cleanup) {
      inst.cleanup();
      delete window.PresentationSlider.instances[id];
    }
  });

  // MutationObserver pour ajouts dynamiques éventuels
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('presentation-slider-section')) {
            initFromContainer(node);
          } else {
            var inner = node.querySelector && node.querySelector('.presentation-slider-section');
            if (inner) initFromContainer(inner);
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // API publique simple (optionnelle)
  window.PresentationSlider.init = function (sectionId, options) {
    // Compat rétro: si on reçoit (sectionId, options) sans container
    var wrapper = document.querySelector('#shopify-section-' + sectionId);
    var container = wrapper && wrapper.querySelector('.presentation-slider-section');
    if (!container) {
      // fallback: cherche par data-section-id
      container = document.querySelector('.presentation-slider-section[data-section-id="' + sectionId + '"]');
    }
    if (!container) {
      console.warn('[PresentationSlider.init] conteneur introuvable pour', sectionId);
      return;
    }
    var merged = {
      autoSlide: !!(options && options.autoSlide),
      slideDuration: (options && parseInt(options.slideDuration, 10)) || 5000
    };
    initSlider(sectionId, container, merged);
  };

  window.PresentationSlider.cleanup = function (sectionId) {
    var inst = window.PresentationSlider.instances[sectionId];
    if (inst && inst.cleanup) {
      inst.cleanup();
      delete window.PresentationSlider.instances[sectionId];
    }
  };

  window.PresentationSlider.cleanupAll = function () {
    Object.keys(window.PresentationSlider.instances).forEach(function (id) {
      window.PresentationSlider.cleanup(id);
    });
  };
})();